const TOOLTIP_TRIANGLE_OFFSET = 7;
const LIST_VIEW_PROJECT_CELL_CANVAS_FONT = 'normal normal normal 14px Lato-Regular, sans-serif';
const LIST_VIEW_PROJECT_CELL_PADDING_RIGHT = 4;

let textMeasureCanvas;
let textMeasureContext;

function getTextMeasureContext() {
  if (!textMeasureContext) {
    textMeasureCanvas = document.createElement('canvas');
    textMeasureContext = textMeasureCanvas.getContext('2d');
    textMeasureContext.font = LIST_VIEW_PROJECT_CELL_CANVAS_FONT;
  }

  return textMeasureContext;
}

export function resolveElementTextAreaWidth(element) {
  if (!element) {
    return 0;
  }

  return element.clientWidth - LIST_VIEW_PROJECT_CELL_PADDING_RIGHT;
}

export function isElementTextEllipsied(element, { text, textAreaWidth } = {}) {
  if (!element) {
    return false;
  }

  const resolvedText = text ?? element.textContent?.trim();

  if (!resolvedText) {
    return false;
  }

  if (typeof textAreaWidth !== 'number' || textAreaWidth <= 0) {
    return false;
  }

  const ctx = getTextMeasureContext();
  const textWidth = ctx.measureText(resolvedText).width;

  return textWidth > textAreaWidth + 1;
}

export function getListViewTooltipBlockerRects(element) {
  const tableRoot = element?.closest('#table_wrapper_copy')
    || element?.closest('[class*="table_wrapper"]');

  if (!tableRoot) {
    return [];
  }

  const selectors = [
    '.header-row',
    '[data-list-view-subheader]',
    '.groupHeaderSticky',
  ];
  const rects = [];

  selectors.forEach(selector => {
    tableRoot.querySelectorAll(selector).forEach(blocker => {
      const rect = blocker.getBoundingClientRect();

      if (rect.height > 0 && rect.bottom > 0) {
        rects.push(rect);
      }
    });
  });

  return rects;
}

export function wouldTooltipOverlapBlockers(triggerRect, tooltipHeight, yOffset, blockerRects) {
  if (!triggerRect || !blockerRects.length) {
    return false;
  }

  const tooltipTop = triggerRect.top - tooltipHeight - TOOLTIP_TRIANGLE_OFFSET + yOffset;

  return blockerRects.some(blockerRect => (
    tooltipTop < blockerRect.bottom
    && blockerRect.top < triggerRect.top
  ));
}

export function resolveListViewTooltipPositionAtShow(
  element,
  triggerRect,
  tooltipHeight,
  yOffset,
  preferredPosition = 'top',
) {
  if (!element || preferredPosition !== 'top') {
    return preferredPosition;
  }

  const blockerRects = getListViewTooltipBlockerRects(element);

  return wouldTooltipOverlapBlockers(triggerRect, tooltipHeight, yOffset, blockerRects)
    ? 'bottom'
    : preferredPosition;
}

export function syncProjectCellTooltipState(element, state, options = {}) {
  if (!element || !state) {
    return;
  }

  const nextIsEllipsied = isElementTextEllipsied(element, {
    text: state.displayValue,
    textAreaWidth: options.textAreaWidth,
  });

  if (state.isEllipsied !== nextIsEllipsied) {
    state.isEllipsied = nextIsEllipsied;
  }
}
